// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G2diD","content":"styles_content__3tpio"};